import { Col, Collapse, DatePicker, Layout, message, Row, Select } from "antd";
import { useEffect, useMemo, useRef, useState } from "react";
import "./dashboard.css";
import moment from "moment";
import { CategoryScale } from "chart.js";
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import DashboardCards from "./dashboardCards";
import { PDFDocument, rgb } from "pdf-lib";

import { saveAs } from "file-saver";
import dayjs from "dayjs";
import secureLocalStorage from "react-secure-storage";

import ChartWithPDF from "./chartwithpdf";
import AuditCount from "./auditCount";
import CustomLoader from "../customLoader";

import media from "../../../media";
import TopContainerHeader from "../../../components/molecules/TopComponentHeader";
import {
  fetchAgentClientsAsDropdownThunk,
  fetchClientAgentsAsDropdownThunk,
  fetchClientsAsDropdownThunk,
  fetchDashboardThunk,
  fetchDashboardUsersThunk,
  fetchDepartmentAuditFormsAsropdownThunk,
  fetchDepartmentClientsAsropdownThunk,
  fetchDepartmentsThunk,
} from "../../../store/thunks/dashboardThunk";
import { useDispatch, useSelector } from "react-redux";
import { createAccessMap, hasPermission } from "../../../utils/permissions";
import Unauthorized from "../../layouts/Unauthorized";
import { buildSortedOptions } from "../../../utils/Constants";

Chart.register(CategoryScale, ChartDataLabels);

const outerRingPlugin = {
  id: "outerRing",
  afterDraw(chart) {
    const { ctx } = chart;
    const activeElements = chart.getActiveElements();

    if (!activeElements.length) return;

    activeElements.forEach(({ element: arc }) => {
      ctx.save();

      const lineWidth = 25; // thickness of outer ring

      // CRITICAL: attach ring exactly to outer edge
      const ringRadius = arc.outerRadius + lineWidth / 2;

      ctx.beginPath();
      ctx.arc(arc.x, arc.y, ringRadius, arc.startAngle, arc.endAngle);

      ctx.lineWidth = lineWidth;
      ctx.strokeStyle = "#EBF3FF"; // hover ring color
      ctx.lineCap = "round"; // smoother edge
      ctx.stroke();

      ctx.restore();
    });
  },
};

Chart.register(outerRingPlugin);
const Dashboard = () => {
  const dispatch = useDispatch();
  const { Content } = Layout;
  const { Panel } = Collapse;
  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const rawAccess = useSelector((state) => state.auth.access);
  const slsRole = secureLocalStorage.getItem("role");
  const slsToken = secureLocalStorage.getItem("accessToken");
  const slsLIUId = secureLocalStorage.getItem("lIUId");
  const slsSelectedMonthRange =
    secureLocalStorage.getItem("selectedMonthRange");
  // Initialize with the current month
  const currentMonth = dayjs();
  const minMonth = dayjs("2023-11");

  const [defaultValue, setDefaultValue] = useState([
    currentMonth,
    currentMonth,
  ]);
  const [rangeValue, setRangeValue] = useState([currentMonth, currentMonth]);
  const [isValid, setIsValid] = useState(true);
  const [selectedMonthRange, setSelectedMonthRange] = useState("");
  const initialMonth = currentMonth.format("MMM, YYYY");

  const startOfMonth = currentMonth.startOf("month");
  const endOfMonth = currentMonth.endOf("month");
  const [startMonth, setStartMonth] = useState(
    startOfMonth.format("MMM, YYYY"),
  );
  const [endMonth, setEndMonth] = useState(endOfMonth.format("MMM, YYYY"));

  const [clients, setClients] = useState([]);
  const [agents, setAgents] = useState([]);
  const [tls, setTls] = useState([]);
  const [atls, setAtls] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [auditForms, setAuditForms] = useState([]);
  const [qcs, setQcs] = useState([]);
  const [auditors, setAuditors] = useState([]);

  const [dashboardDetails, setDashboardDetails] = useState({});
  const [showLoader, setShowLoader] = useState(true);

  const [selectedAuditedBy, setSelectedAuditedBy] = useState([]);
  const [selectedClients, setSelectedClients] = useState([]);
  const [selectedTls, setSelectedTls] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [selectedAuditForms, setSelectedAuditForms] = useState([]);
  const [selectedAuditors, setSelectedAuditors] = useState([]);
  const [selectedAgents, setSelectedAgents] = useState([]);

  const accessMap = useMemo(() => {
    return createAccessMap(rawAccess);
  }, [rawAccess]);

  const hasViewAccess = hasPermission(accessMap, "dashboard", "view");

  const handleRangeChange = (dates) => {
    if (!dates) {
      setStartMonth(defaultValue[0].format("MMM, YYYY")); // Reset start month
      setEndMonth(defaultValue[1].format("MMM, YYYY")); // Reset end month
      setSelectedMonthRange(defaultValue[0].format("MMM, YYYY"));
      // Reset if clear is clicked
      setRangeValue([currentMonth, currentMonth]);
      setIsValid(true);
      return;
    }

    const [start, end] = dates;
    const startMonth = start.format("MMM, YYYY");
    const endMonth = end.format("MMM, YYYY");

    // Check if the start month is before 2023-11
    if (start.isSame(end, "month")) {
      // If both are from the same month
      setStartMonth(startMonth); //For Filter
      setEndMonth(startMonth); //For Filter
      setSelectedMonthRange(startMonth); //Showing on JSX
      setIsValid(true);
    } else if (dayjs(start.format("YYYY-MM")).isBefore(minMonth)) {
      setRangeValue([currentMonth, currentMonth]);
      setIsValid(false);
      setSelectedMonthRange(`${startMonth} - ${endMonth}`); //Showing on JSX
      message.error(
        `Cannot select months before ${minMonth.format("MMM, YYYY")}`,
      );
    } else {
      setIsValid(true);
      setRangeValue(dates);
      setStartMonth(startMonth); //For Filter
      setEndMonth(endMonth); //For Filter
      setSelectedMonthRange(`${startMonth} - ${endMonth}`); //Showing on JSX
    }
  };

  {
    /*Fetch Agent's Tls*/
  }
  const handleAgentTls = (agentID) => {};

  const handleDepartmentChange = () => {};
  {
    /*Fetch Tl's Atls*/
  }
  const handleTlAtls = (tlID) => {};

  {
    /*Fetch Client's Agents*/
  }

  const handleClientAgents = async (lIUId) => {
    const payload = {
      route: "clientAgents",
      action: "findAll",
      slsRole,
      lIUId,
    };

    const result = await dispatch(
      fetchClientAgentsAsDropdownThunk(payload),
    ).unwrap();

    const clientAgentInfo = Array.isArray(result) ? result : [];

    const temp = clientAgentInfo.map((clientAgent) => ({
      label: clientAgent.name,
      value: clientAgent._id,
    }));

    setAgents(buildSortedOptions(clientAgentInfo, "name", "_id", true));
  };

  const handleDepartmentAuditForms = async (val) => {
    const payload = {
      route: "departmentAuditForms",
      action: "findAll",
      slsRole,
      slsLIUId,
      value: val,
    };

    const result = await dispatch(
      fetchDepartmentAuditFormsAsropdownThunk(payload),
    ).unwrap();

    const departmentAuditFormsInfo = Array.isArray(result) ? result : [];

    setAuditForms(
      buildSortedOptions(departmentAuditFormsInfo, "formName", "_id"),
    );
  };

  const handleDepartmentClients = async (val) => {
    const payload = {
      route: "departmentClients",
      action: "findAll",
      slsRole,
      slsLIUId,
      value: val,
    };

    const result = await dispatch(
      fetchDepartmentClientsAsropdownThunk(payload),
    ).unwrap();

    const departmentClientsInfo = Array.isArray(result) ? result : [];

    setClients(buildSortedOptions(departmentClientsInfo, "name", "_id"));
  };

  const submitDashboardFilters = async () => {
    try {
      setShowLoader(true);

      secureLocalStorage.setItem(
        "selectedMonthRange",
        selectedMonthRange || initialMonth,
      );

      const payload = {
        role: slsRole,
        lIUId: slsLIUId,
        filterValues: {
          startMonth,
          endMonth,
          auditedBy: selectedAuditedBy,
          clients: selectedClients,
          agents: selectedAgents,
          // tls:
          //   slsRole === process.env.REACT_APP_MGRROLE &&
          //   selectedTls.length === 0
          //     ? tls
          //     : selectedTls,
          tls: selectedTls,
          departments: selectedDepartments,
          auditForms: selectedAuditForms,
          auditors: selectedAuditors,
        },
      };

      const result = await dispatch(fetchDashboardThunk(payload)).unwrap();

      setDashboardDetails(result);
    } catch (err) {
      console.error("Dashboard submit failed", err);
    } finally {
      setShowLoader(false);
    }
  };

  const onFilterChange = async (type, value) => {
    switch (type) {
      case "auditedBy":
        setSelectedAuditedBy(value || []);
        break;

      case "departments":
        setSelectedDepartments(value || []);
        setClients([]);
        setAuditForms([]);

        await handleDepartmentAuditForms(value || []);

        await handleDepartmentClients(value || []);
        break;

      case "auditForms":
        setSelectedAuditForms(value || []);
        //await handleDepartmentAuditForms(value || []);
        break;

      case "clients":
        setSelectedClients(value || []);
        setAgents([]);
        await handleClientAgents(value || []);
        break;

      case "agents":
        setSelectedAgents(value || []);
        setTls([]);
        await handleAgentTls(value || []);
        break;

      case "tls":
        setSelectedTls(value || []);
        setAtls([]);
        await handleTlAtls(value || []);
        break;

      case "auditors":
        setSelectedAuditors(value || []);
        break;

      case "month":
        handleRangeChange(value);
        break;
      default:
        break;
    }
  };

  /*begin::getUsers*/
  const getUsers = async () => {
    try {
      const payload = {
        route: "users",
        action: "findAll",
        fields: ["qc", "auditor", "tl", "atl"],
        role: slsRole,
        lIUId: slsLIUId,
      };

      const result = await dispatch(fetchDashboardUsersThunk(payload)).unwrap();

      const userInfo = Array.isArray(result) ? result : [];

      if (!userInfo.length) {
        console.warn("No users returned from API", result);
        return;
      }

      // =========================
      // TLs
      // =========================

      const getAllTls = userInfo?.filter(
        (user) => user?.role === process.env.REACT_APP_TLROLE,
      );

      const filteredTls =
        slsRole.trim() === process.env.REACT_APP_MGRROLE.trim()
          ? getAllTls?.filter((user) => user?.manager === slsLIUId)
          : getAllTls;
      setTls(buildSortedOptions(filteredTls, "name", "_id", true));

      // =========================
      // QCs
      // =========================

      const storeAllQcs = [];
      const getAllQcs = userInfo?.filter(
        (user) => user?.role === process.env.REACT_APP_QC,
      );

      setQcs(buildSortedOptions(getAllQcs, "name", "_id", true));
      // =========================
      // Auditors
      // =========================
      const storeAllAuditors = [];
      const getAllAuditors = userInfo?.filter(
        (user) => user?.role === process.env.REACT_APP_AUDROLE,
      );

      setAuditors(buildSortedOptions(getAllAuditors, "name", "_id", true));
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };
  /*end::getUsers*/

  /*begin::getDepartments*/
  const getDepartments = async () => {
    const payload = { route: "departments", action: "findAll" };

    const result = await dispatch(fetchDepartmentsThunk(payload)).unwrap();

    const departmentInfo = Array.isArray(result) ? result : [];

    setDepartments(buildSortedOptions(departmentInfo));
  };
  /*end::getDepartments*/

  const getDashboardDetails = async () => {
    try {
      secureLocalStorage.setItem(
        "selectedMonthRange",
        selectedMonthRange || initialMonth,
      );

      const payload = {
        role: slsRole,
        lIUId: slsLIUId,
        filterValues: {
          initialMonth: !selectedMonthRange,
          startMonth,
          endMonth,
          clients: [],
          tls: [],
          departments: [],
          auditForms: [],
          auditors: [],
          agents: [],
        },
      };

      const result = await dispatch(fetchDashboardThunk(payload)).unwrap();

      if (result) {
        setDashboardDetails(result);
        setShowLoader(false);
      }
    } catch (error) {
      const errorMessage = error.data?.message || "An error occurred";
    }
  };
  useEffect(() => {
    if (!slsRole || !slsToken || !slsLIUId) return;

    getUsers();
    getDepartments();
    if (slsRole === process.env.REACT_AGROLE) {
      getAgentClients();
    } else {
      //getClients();
    }
  }, [slsRole, slsToken, slsLIUId]);

  useEffect(() => {
    if (!slsRole || !slsToken || !slsLIUId) return;

    getDashboardDetails();
  }, [slsRole, slsToken, slsLIUId]);

  // New Client Wise Chart Data
  const clientWiseChartdata = {
    labels: dashboardDetails?.clientWiseAuditScore?.labels,
    datasets: [
      {
        label: slsSelectedMonthRange,
        data: dashboardDetails?.clientWiseAuditScore?.values,
        backgroundColor: "#112C7D",
        hoverBackgroundColor: "#BBCCFD",
        barThickness: 15,
        barPercentage: 0.7,
        categoryPercentage: 0.5,
        // FORCE all borders
        borderSkipped: false,
        borderRadius: 5,
      },
    ],
  };

  const clientWiseChartoptions = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    scales: {
      x: {
        grid: {
          display: false, // remove horizontal grid
          drawBorder: false, // remove y-axis line
        },

        title: {
          display: false,
          text: "Values",
        },
        ticks: {
          stepSize: 20,
          callback: (value) => {
            return `${value} %`; // Custom formatting for labels
          },
          color: "#000000",
          font: {
            weight: "normal",
            size: 11,
          },
        },
        min: 0,
        max: 100,
      },
      y: {
        //display: false,
        grid: {
          display: false, // remove horizontal grid
          drawBorder: false, // remove y-axis line
        },
        ticks: {
          display: true,
          color: "#000000",
          font: {
            weight: "normal",
            size: 11,
          },
        },
      },
    },

    indexAxis: "y", // Set this to 'y' for horizontal bars
    layout: {
      padding: {
        top: 10,
        right: 80, // Add more space for labels
        bottom: 10,
        left: 10,
      },
    },

    plugins: {
      legend: {
        //position: "left",
        display: false, // hides legend completely
      },
      tooltip: {
        enabled: true,
        backgroundColor: "#ffffff", // dark background
        titleColor: "#70707A",
        bodyColor: "#000000",
        borderColor: "#ffffff",
        borderWidth: 1,
        padding: 10,
        cornerRadius: 6,
        displayColors: false,
        yAlign: "top", // ⬆ show tooltip above bar
        xAlign: "center",

        callbacks: {
          label: (ctx) => `${ctx.raw} %`,
        },
      },
      datalabels: {
        display: true,
        color: "#000000",
        anchor: "end", // Place the label at the end of the bar
        align: "end", // Align the label at the edge of the bar
        clip: false, // Prevent labels from being clipped at the chart's edge
        font: {
          weight: "500",
          size: 12,
        },
        formatter: (value, context) => {
          const month = context.chart.data.labels[context.dataIndex];
          const year = moment.utc(new Date()).local().format("YYYY");
          const currencySymbol = "";
          return `${currencySymbol} ${value} %`;
        },
        backgroundColor: "#ffffff", // Optional: Semi-transparent black background
        borderRadius: 4,
      },
    },
  };

  //Audit Count Table

  const departmentWiseAuditScoreHalfDoughnutLabels =
    dashboardDetails?.departmentWiseAuditScore?.labels || [];
  const departmentWiseAuditScoreHalfDoughnutValues = (
    dashboardDetails?.departmentWiseAuditScore?.values || []
  ).map((v) => Number(v));
  const baseColors = ["#6784DA2E", "#112C7D33", "#041A5A"];
  const departmentWiseAuditScoreHalfDoughnutColors =
    departmentWiseAuditScoreHalfDoughnutLabels.map(
      (_, i) => baseColors[i % baseColors.length],
    );

  const departmentWiseAuditScorePieData = {
    labels: departmentWiseAuditScoreHalfDoughnutLabels,
    datasets: [
      {
        data: departmentWiseAuditScoreHalfDoughnutValues,
        backgroundColor: departmentWiseAuditScoreHalfDoughnutColors,
        borderWidth: 0,

        hoverOffset: 0,
        hoverBorderWidth: 0,
        //hoverBorderColor: ["#EBF3FF", "#EBF3FF", "#EBF3FF"],
      },
    ],
    // labels: dashboardDetails?.departmentWiseAuditScore?.labels,
    // datasets: [
    //   {
    //     data: dashboardDetails?.departmentWiseAuditScore?.values,

    //   },
    // ],
  };

  const departmentWiseChartoptions = {
    responsive: true,
    maintainAspectRatio: false,
    rotation: -90,
    circumference: 180,
    cutout: "65%",
    radius: "80%",

    interaction: {
      mode: "nearest",
      intersect: true,
    },

    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        display: false,
      },

      tooltip: {
        backgroundColor: "#fff",
        titleColor: "#000",
        bodyColor: "#444",
        borderColor: "#F4F4F5",
        borderWidth: 1,
        displayColors: false,
        callbacks: {
          title: () => "",
          label: (ctx) => `${ctx.raw} %`, // value only on hover
        },
      },
    },
  };

  const halfDoughnutData = {
    labels: ["HR", "IT", "Finance", "Admin"],
    datasets: [
      {
        data: [35, 40, 15, 10],
        backgroundColor: ["#4CAF50", "#2196F3", "#FFC107", "#F44336"],
        borderWidth: 1,
      },
    ],
  };
  const chartRef = useRef(null);
  const downloadPDF = async (rf) => {
    const chartCanvas = rf.current.canvas;
    const chartImage = chartCanvas.toDataURL("image/png");

    // Extract chart data
    const labels = rf.current.data.labels;
    const dataset = rf.current.data.datasets[0];

    // Create a new PDF document
    const pdfDoc = await PDFDocument.create();
    const pageWidth = 595; // Width for A4 size in points
    const pageHeight = 842; // Height for A4 size in points

    // ** NEW ** Embed company logo image (replace with your logo URL or data)
    const companyLogoUrl = "/PdfLogo.png"; // Replace this URL with the actual logo path
    const logoImageBytes = await fetch(companyLogoUrl).then((res) =>
      res.arrayBuffer(),
    );
    const logoImage = await pdfDoc.embedPng(logoImageBytes); // or embedJpg if JPG format

    const drawChartOnPage = async (page) => {
      // Embed the chart image into the PDF
      const pngImage = await pdfDoc.embedPng(chartImage);
      page.drawImage(pngImage, {
        x: 20,
        y: pageHeight - 370,
        width: 550,
        height: 300,
      });
    };

    const drawTextOnPage = (page, text, yPosition) => {
      page.drawText(text, {
        x: 20,
        y: yPosition,
        size: 12,
        color: rgb(0, 0, 0),
      });
    };

    const addExpenseDetails = (page, startY) => {
      page.drawText("Expense Details:", {
        x: 20,
        y: startY,
        size: 16,
        color: rgb(0, 0, 0),
      });
      return startY - 20;
    };

    // Start creating pages
    let page = pdfDoc.addPage([pageWidth, pageHeight]);
    let yPosition = pageHeight - 100;

    // Add chart title and company logo side by side
    page.drawText("Expense Report", {
      x: 20,
      y: pageHeight - 50,
      size: 20,
      color: rgb(0, 0, 0),
    });

    page.drawImage(logoImage, {
      x: pageWidth - 120, // Adjust X position based on the logo width
      y: pageHeight - 60, // Adjust Y position based on the logo height
      width: 100, // Set the width of the logo
      height: 30, // Set the height of the logo
    });

    // Add chart
    await drawChartOnPage(page);

    // Initialize for expense details
    yPosition -= 300; // Adjust yPosition based on chart height
    yPosition = addExpenseDetails(page, yPosition); // Add "Expense Details" title only on the first page

    let currentPageIndex = 0;
    const linesPerPage = Math.floor((pageHeight - 100 - 300 - 20) / 20); // Calculate how many lines fit per page
    const totalLines = labels.length;

    const addTextToPage = () => {
      let startIndex = currentPageIndex * linesPerPage;
      let endIndex = Math.min(startIndex + linesPerPage, totalLines);

      if (endIndex <= totalLines) {
        for (let i = startIndex; i < endIndex; i++) {
          const label = labels[i];
          const value = dataset.data[i];
          const currencySymbol = "";
          drawTextOnPage(
            page,
            `${label}: ${currencySymbol}${value} (${moment
              .utc(new Date())
              .local()
              .format("YYYY")})`,
            yPosition,
          );
          yPosition -= 20;
        }

        if (endIndex < totalLines) {
          // If more lines to add, create a new page
          currentPageIndex++;
          page = pdfDoc.addPage([pageWidth, pageHeight]);
          yPosition = pageHeight - 50; // Reset position on new page without re-adding the "Expense Details" title
          addTextToPage(); // Recurse to add remaining lines without re-adding "Expense Details" title
        }
      }
    };

    addTextToPage(); // Start adding text

    // Save the PDF and trigger download
    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    saveAs(blob, "expenseReport.pdf");
  };

  {
    /*Fetch Clients*/
  }
  const getClients = async () => {
    const payload = { route: "clients", action: "findAll" };

    const result = await dispatch(
      fetchClientsAsDropdownThunk(payload),
    ).unwrap();

    const clientInfo = Array.isArray(result) ? result : [];

    // Remove duplicates by _id
    const uniqueClients = Array.from(
      new Map(clientInfo.map((client) => [client._id, client])).values(),
    );

    setClients(buildSortedOptions(uniqueClients));
  };

  {
    /*Fetch Agent's Clients*/
  }

  const getAgentClients = async () => {
    const payload = {
      route: "agentClients",
      action: "findAll",
      slsRole,
      slsLIUId,
    };

    const result = await dispatch(
      fetchAgentClientsAsDropdownThunk(payload),
    ).unwrap();

    const agentClientInfo = Array.isArray(result) ? result : [];

    setClients(buildSortedOptions(agentClientInfo));
  };

  // Dashboard cards
  // 1️⃣ Audit Count & Invoice Count
  // <b>+10 (↑5%)</b> More from last month
  const countGrowth = (current = 0, previous = 0) => {
    if (!current && !previous) {
      return { show: true, message: "<b>0</b> More from last month" };
    }

    if (!previous) {
      return {
        show: true,
        message: `<b>+${current} (↑100%)</b> More from last month`,
      };
    }

    const diff = current - previous;
    const percent = Math.abs(((diff / previous) * 100).toFixed(2));

    const formatToK = (value = 0) => {
      const abs = Math.abs(value);

      if (abs < 1000) return abs;

      return `${String(Math.floor(abs)).slice(0, -3)}K`;
    };

    const sign = diff > 0 ? "+" : "-";
    const arrow = diff >= 0 ? "↑" : "↓";
    const tooltipText = `${sign}${Math.abs(diff)} (${arrow}${percent}%) More from last month`;

    return {
      show: true,
      message: `
        <b class="dashBrdCardToolTip" title="${tooltipText}">
          ${sign}${formatToK(diff)} (${arrow}${percent}%)
        </b> More from last month
      `,
    };
  };

  // Overall Audit Score
  // <b>0.3%</b> More from last month
  const percentageGrowth = (current, previous) => {
    const curr = Number(current);
    const prev = Number(previous);

    // If current itself is invalid
    if (Number.isNaN(curr)) {
      return {
        show: true,
        message: "<b>0%</b> More from last month",
      };
    }

    // If last month missing or invalid
    if (Number.isNaN(prev) || prev === 0) {
      return {
        show: true,
        message: `<b>${curr.toFixed(2)}%</b> More from last month`,
      };
    }

    const diff = Number((curr - prev).toFixed(2));

    return {
      show: true,
      message: `<b>${diff}%</b> More from last month`,
    };
  };

  // Fatal & Not-Fatal Count
  // <b>+2</b> incidents from last month
  const incidentGrowth = (current = 0, previous = 0) => {
    const curr = Number(current) || 0;
    const prev = Number(previous) || 0;

    const diff = curr - prev;
    const sign = diff >= 0 ? "+" : "-";

    return {
      show: true,
      message: `<b>${sign}${Math.abs(diff)}</b> incidents from last month`,
    };
  };

  const dashboardCards = useMemo(() => {
    if (!dashboardDetails) return [];

    return [
      {
        isVisible: true,
        itemName: "Audit Count",
        itemValue: dashboardDetails.auditCount ?? 0,
        itemIcon: media.auditCount.svg,
        growth: countGrowth(
          dashboardDetails.auditCount ?? 0,
          dashboardDetails.lastMonth?.auditCount ?? 0,
        ),
      },
      {
        isVisible: true,
        itemName: "Overall Audit Score",
        itemValue: `${dashboardDetails.overallAuditScore ?? 0}%`,
        itemIcon: media.auditScore.svg,
        growth: percentageGrowth(
          dashboardDetails.overallAuditScore,
          dashboardDetails.lastMonth?.overallAuditScore,
        ),
      },
      {
        isVisible: true,
        itemName: "Invoice Count",
        itemValue: dashboardDetails.invoiceCount ?? 0,
        itemIcon: media.invoiceCount.svg,
        growth: countGrowth(
          dashboardDetails.invoiceCount,
          dashboardDetails.lastMonth?.invoiceCount,
        ),
      },
      {
        isVisible: true,
        itemName: "Transaction Amount",
        itemValue: dashboardDetails.transactionAmount ?? 0,
        itemIcon: media.invoiceCount.svg,
        growth: countGrowth(
          dashboardDetails.transactionAmount,
          dashboardDetails.lastMonth?.transactionAmount,
        ),
      },
      {
        isVisible: true,
        itemName: "Fatal Count",
        itemValue: dashboardDetails.fatalCount ?? 0,
        itemIcon: media.fatelCount.svg,
        growth: incidentGrowth(
          dashboardDetails.fatalCount,
          dashboardDetails.lastMonth?.fatalCount,
        ),
      },
      {
        isVisible: true,
        itemName: "Not-Fatal Count",
        itemValue: dashboardDetails.notFatalCount ?? 0,
        itemIcon: media.nonFatelCount.svg,
        growth: incidentGrowth(
          dashboardDetails.notFatalCount,
          dashboardDetails.lastMonth?.notFatalCount,
        ),
      },
    ];
  }, [dashboardDetails]);

  if (!hasViewAccess) {
    return <Unauthorized />;
  }
  return (
    <>
      <Layout>
        <CustomLoader showLoader={showLoader} />

        <TopContainerHeader
          sectionTitle="Dashboard"
          sectionDescription=""
          hasSectionButton={false}
          hasFilter={
            hasPermission(accessMap, "dashboard", "dashboardfilterview") && true
          }
          buttonTitle=""
          filters={
            hasPermission(accessMap, "dashboard", "dashboardfilterview") && {
              clients,
              agents,
              tls,
              departments,
              auditForms,
              auditors,
              isValid,
              onFilterChange,
              onSubmit: submitDashboardFilters,
            }
          }
        />
        <Content className="dContent">
          <div className="graph-outer-container">
            {/* <p className="namelinkclass">{slsSelectedMonthRange}</p> */}
            <div className="graph-inner-container">
              {/* Dashboard Cards */}
              <div className="dashboardCardsWrap">
                {dashboardCards.map(
                  (card, i) =>
                    card.isVisible && <DashboardCards key={i} {...card} />,
                )}
              </div>
              <Row gutter={[16, 16]} className="mt-20 dashboardGraphWrap">
                {/* Audit Count */}
                <AuditCount
                  chartFor="Audit Count"
                  barCount={
                    dashboardDetails?.auditCounts?.["Audit Count"]?.labels
                      ?.length || 0
                  }
                  chartKey={`${"Audit Count"}-${
                    dashboardDetails?.auditCounts?.["Audit Count"]?.labels
                      ?.length
                  }-${slsSelectedMonthRange}`}
                  slsRole={slsRole}
                  slsSelectedMonthRange={slsSelectedMonthRange}
                  dashboardDetails={dashboardDetails}
                  barBackgroundColor="#112C7D"
                  marginTop=""
                  fileName={process.env.REACT_APP_AUDIT_COUNT_FILENAME}
                />

                {(slsRole === process.env.REACT_APP_TLROLE ||
                  slsRole === process.env.REACT_APP_ATLROLE ||
                  slsRole === process.env.REACT_APP_AUDROLE ||
                  slsRole === process.env.REACT_APP_QC) && (
                  <AuditCount
                    chartFor="Agent Audit Count"
                    barCount={
                      dashboardDetails?.auditCounts?.["Agent Audit Count"]
                        ?.labels?.length || 0
                    }
                    chartKey={`${"Agent Audit Count"}-${
                      dashboardDetails?.auditCounts?.["Agent Audit Count"]
                        ?.labels?.length
                    }-${slsSelectedMonthRange}`}
                    slsRole={slsRole}
                    slsSelectedMonthRange={slsSelectedMonthRange}
                    dashboardDetails={dashboardDetails}
                    barBackgroundColor="#112C7D"
                    marginTop={
                      slsRole === process.env.REACT_APP_QC ? "" : "mt-4"
                    }
                    fileName={process.env.REACT_APP_AGENT_AUDIT_COUNT_FILENAME}
                  />
                )}

                {/* Department Wise Audit Score */}
                {slsRole === process.env.REACT_APP_AROLE && (
                  <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                    <div className="card px-3 py-4">
                      <div className="d-flex justify-content-between gp-10">
                        <p className="dsh-chart-p m-0">
                          Department Wise Audit Score
                        </p>
                      </div>

                      <ChartWithPDF
                        type="half-doughnut"
                        // resHeight="400"
                        data={departmentWiseAuditScorePieData}
                        options={departmentWiseChartoptions}
                        vLegendLabels={
                          departmentWiseAuditScoreHalfDoughnutLabels
                        }
                        vLegendValues={
                          departmentWiseAuditScoreHalfDoughnutValues
                        }
                        vLegendColors={
                          departmentWiseAuditScoreHalfDoughnutColors
                        }
                        fileName="Department_Wise_Audit_Count"
                        customClass=""
                        chartFor=""
                      />
                    </div>
                  </Col>
                )}
              </Row>
              <Row gutter={16} className="mt-20 dashboardGraphWrap">
                {(slsRole === process.env.REACT_APP_VPRROLE ||
                  slsRole === process.env.REACT_APP_QC) && (
                  <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                    <div className="card px-3 py-4">
                      <div className="d-flex justify-content-between gp-10">
                        <p className="dsh-chart-p m-0">
                          Department Wise Audit Score
                        </p>
                      </div>

                      <ChartWithPDF
                        type="half-doughnut"
                        data={departmentWiseAuditScorePieData}
                        options={departmentWiseChartoptions}
                        vLegendLabels={
                          departmentWiseAuditScoreHalfDoughnutLabels
                        }
                        vLegendValues={
                          departmentWiseAuditScoreHalfDoughnutValues
                        }
                        vLegendColors={
                          departmentWiseAuditScoreHalfDoughnutColors
                        }
                        fileName="Department_Wise_Audit_Count"
                        customClass=""
                        chartFor=""
                      />
                    </div>
                  </Col>
                )}
                <Col
                  xs={24}
                  sm={24}
                  md={
                    slsRole === process.env.REACT_APP_VPRROLE ||
                    slsRole === process.env.REACT_APP_QC
                      ? 16
                      : 24
                  }
                  lg={
                    slsRole === process.env.REACT_APP_VPRROLE ||
                    slsRole === process.env.REACT_APP_QC
                      ? 16
                      : 24
                  }
                  xl={
                    slsRole === process.env.REACT_APP_VPRROLE ||
                    slsRole === process.env.REACT_APP_QC
                      ? 16
                      : 24
                  }
                >
                  <div className="card px-3 py-4">
                    <div className="d-flex justify-content-between gp-10">
                      <p className="dsh-chart-p m-0">Client Wise Audit Score</p>
                    </div>
                    <ChartWithPDF
                      type="bar"
                      data={clientWiseChartdata}
                      options={clientWiseChartoptions}
                      fileName="Client_Wise_Audit_Score"
                      customClass="clientAuditScore"
                      chartFor=""
                      leftContent="Clients"
                      bottomContent="Audit Score"
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Content>
      </Layout>
    </>
  );
};

export default Dashboard;
